import BaseScene from './core/base-scene';
import { inject } from '@vercel/analytics';
import { prefersReducedMotion } from './utils/motion-preference';

const BACK_TRANSITION_MS = 320;

inject();

const baseScene = new BaseScene();

document.addEventListener('onLoad', () => {
  baseScene.createGameScene();
});

document.addEventListener('onReadyToReveal', () => {
  baseScene.afterAssetsLoaded();
});

function initBackButtonExit(): void {
  const backButton = document.querySelector<HTMLAnchorElement>('.back-button');

  if (!backButton) {
    return;
  }

  // Browsers with cross-document view transitions crossfade the navigation
  // natively (see @view-transition in design-tokens.css) — flash-free without
  // any JS involvement. Only run the manual opacity fade as a fallback where
  // that isn't available.
  const supportsViewTransitions = 'startViewTransition' in document;

  backButton.addEventListener('click', (event: MouseEvent) => {
    const isModifiedClick = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;

    if (isModifiedClick || prefersReducedMotion() || supportsViewTransitions) {
      return;
    }

    event.preventDefault();
    document.body.classList.add('page-exit');

    window.setTimeout(() => {
      window.location.href = backButton.href;
    }, BACK_TRANSITION_MS);
  });
}

initBackButtonExit();
